import {
  Organization,
  type OrganizationAttributesType
} from './Ambiguous'

export class LoadedOrganization<T extends OrganizationAttributesType = OrganizationAttributesType> extends Organization<T> {
  readonly isLoaded: true = true

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor (attributes: T) {
    super(attributes)
  }

  /* eslint-disable @typescript-eslint/class-literal-property-style */
  get isAtom (): true { return true }
  get isAggregate (): true { return true }
  /* eslint-enable @typescript-eslint/class-literal-property-style */
}
